import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useShipperNetworkGroups() {
  const { role } = useRoleContext();

  const url =
    role?.type === "SHIPPER" ? `/shippers/${role.id}/network-groups` : null;

  const { data, loading, error, refetch } = useSwrFetch<NetworkGroup[]>({
    url,
    errorMessage: "Failed to fetch network groups",
  });

  return {
    networkGroups: data ?? [],
    loadingNetworkGroups: loading,
    networkGroupsError: error,
    refetchNetworkGroups: refetch,
    networkGroupsFetchSuccess: data !== undefined,
  };
}
